import { useLocalStorage } from 'usehooks-ts';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Row } from 'further-ui/components/Layout';
import VerticalTabs from 'components/new/VerticalTabs';
import InvestorAndReviewSettings from './InvestorAndReviewSettings';
import TaxSettings from './TaxSettings';
import KycSettings from './KycSettings';
import KybSettings from './KybSettings';
import { OnboardingSettingsTab } from '../types';
import { useHasPermissions } from 'hooks/ui/usePermissions';
import { RolePermission } from 'further-types/admin-user-role';

const Container = styled(Box)({
  width: '100%',
  maxWidth: '600px',
});

const tabs = [
  {
    label: 'Investor and review settings',
    id: OnboardingSettingsTab.InvestorAndReviewSettings,
  },
  {
    label: 'KYC settings',
    id: OnboardingSettingsTab.KycSettings,
  },
  {
    label: 'KYB settings',
    id: OnboardingSettingsTab.KybSettings,
  },
  {
    label: 'Tax settings',
    id: OnboardingSettingsTab.TaxSettings,
  },
];

type Props = {
  vehicleId: string;
};

const OnboardingSettings: React.FC<Props> = ({ vehicleId }) => {
  const [currentOnboardingSettingsTab, setCurrentOnboardingSettingsTab] =
    useLocalStorage<OnboardingSettingsTab>(
      `current-onboarding-settings-tab-${vehicleId}`,
      OnboardingSettingsTab.InvestorAndReviewSettings,
    );
  const [canEdit] = useHasPermissions([RolePermission.LpEditVehicle]);
  const disabled = !canEdit;

  return (
    <Row>
      <VerticalTabs
        selectedTab={currentOnboardingSettingsTab}
        tabs={tabs}
        renderContent={(tab) => (
          <Container>
            {tab === OnboardingSettingsTab.InvestorAndReviewSettings && (
              <InvestorAndReviewSettings
                vehicleId={vehicleId}
                disabled={disabled}
              />
            )}
            {tab === OnboardingSettingsTab.KycSettings && (
              <KycSettings vehicleId={vehicleId} disabled={disabled} />
            )}
            {tab === OnboardingSettingsTab.KybSettings && (
              <KybSettings vehicleId={vehicleId} disabled={disabled} />
            )}
            {tab === OnboardingSettingsTab.TaxSettings && (
              <TaxSettings vehicleId={vehicleId} disabled={disabled} />
            )}
          </Container>
        )}
        onTabChange={setCurrentOnboardingSettingsTab}
      />
    </Row>
  );
};

export default OnboardingSettings;
